export const siteSettings = {
  name: "Unified Finance Assets",
  link: "https://unifiedfinanceassets.com",
  email: "support@unifiedfinanceassets.com",
  appLink: "https://app.unifiedfinanceassets.com",
};
